

function IcoUbicacion({width="64",height="64"}) {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="currentColor"  strokeLinejoin="round">
        <path d="M11.5 5c0 2.49-4.5 8.5-4.5 8.5S2.5 7.49 2.5 5a4.5 4.5 0 0 1 9 0Z"/>
        <circle cx="7" cy="5" r="1.5"/>
    </g>
</svg>
  );
}

export default IcoUbicacion;
